import React from 'react';
import styles from './PrivacyPolicy.module.css';
import privacyImg from './privacy-policy-img.png';
import BackButton from '../BackButton';
import Navbar from '../Navbar/Navbar';

const PrivacyPolicy = () => {
  const policyData = [
    {
      title: '1. What Personal Information We Collect',
      text: 'We collect information that helps us identify and communicate with you. This may include your name, email address, phone number, postal address, device information, and usage data such as browsing activity on our website or app. In some cases, we may also collect location data or demographic information.'
    },
    {
      title: '2. What We Do With the Personal Information We Collect',
      text: 'We use your personal information to provide, maintain, and improve our services. This includes personalizing content, responding to inquiries, processing transactions, and sending updates or marketing communications (with your consent). We also use this data to analyze usage trends and enhance user experience.'
    },
    {
      title: '3. When We Disclose Personal Information',
      text: 'We may share your information with trusted third parties for the purpose of service delivery, such as payment processors or cloud storage providers. We only share the minimum necessary information and ensure partners uphold strong privacy standards. We may also disclose data if legally required or to protect our rights.'
    },
    {
      title: '4. How We Use Cookies and Collect Information Using Technology',
      text: 'We use cookies, pixels, and other tracking technologies to enhance your browsing experience. These tools allow us to remember your preferences, analyze website traffic, and deliver targeted content or ads. You can manage or disable cookies through your browser settings.'
    },
    {
      title: '5. Security',
      text: 'We implement industry-standard security measures to protect your personal information from unauthorized access, loss, misuse, or alteration. This includes encryption, access controls, and secure storage. While we strive to protect your data, no system is 100% secure, so we encourage caution with sensitive information.'
    },
    {
      title: '6. We May Transfer Personal Information to Other Countries',
      text: 'As part of our global operations, your data may be stored or processed in countries outside your own. These countries may have different privacy laws, but we take steps to ensure your information remains protected and compliant with relevant regulations, such as GDPR or similar frameworks.'
    },
    {
      title: '7. Links to Other Websites',
      text: 'Our site may contain links to external websites. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to read the privacy policies of any site you visit through our platform.'
    },
    {
      title: '8. Your Choices',
      text: 'You have control over how your personal information is used. You can opt out of marketing emails, adjust cookie settings, and request to access or delete your data. We honor your choices in accordance with applicable privacy laws.'
    },
    {
      title: '9. Accessing and Correcting Your Personal Information',
      text: 'You may request access to the personal information we hold about you, and ask for corrections if it is inaccurate or incomplete. We provide reasonable means for you to update your data and ensure it is accurate and up to date.'
    },
    {
      title: '10. Children',
      text: 'Our services are not intended for individuals under the age of 13 (or the age defined by local law). We do not knowingly collect personal data from children. If we become aware of such collection, we take steps to delete the information promptly.'
    },
    {
      title: '11. Contact Us',
      text: 'If you have any questions, concerns, or requests regarding your personal information or our privacy practices, please contact us through our designated support channels or via email.'
    }
  ];

  return (
    <div className={styles.privacyContainer}>

      <h2 className={styles.title}>Privacy Policy</h2>
      <hr />

      <section className={styles.intro}>
        <div className={styles.textContainer}>
          {/* <div className={styles.text}>
            <h3>
              We develop advanced AI audio models that generate speech, voices, and sound effects that are realistic, expressive, and context-aware — across thirty-two languages. And thanks to tools like Toxbox.ai, these voices come to life in a way that’s natural and immersive.
            </h3>
            <p>
              Our product team shapes these models for real-world use — whether you’re a creator, a business, or just someone with a story to tell. From audiobooks and video games, to social media, advertising, and even medical training — our technology powers dynamic, human-like audio.
            </p>
            <p>
              It’s also helped restore voices to those who have lost them… and made daily life more accessible for individuals with unique communication needs.
              At ElevenLabs, we take the impact of our tools seriously. AI-generated voices are a glimpse into the future of digital interaction — and safety is our top priority. With platforms like Toxbox.ai, we ensure these voices are not only powerful, but also responsibly used.
              Our goal is to create technology that’s safe, innovative, and empowering — driving creative expression, global communication, and meaningful change.
            </p>
          </div> */}

          <h3 className={styles.tocTitle}>Table of Contents</h3>
          <div className={styles.tocGrid}>
            {[
              'What Personal Information we collect',
              'What We Do with the Personal Information We Collect',
              'When We Disclose Personal Information',
              'How We Use Cookies and Collect Information Using Technology',
              'Security',
              'We May Transfer Personal Information to Other Countries',
              'Links to Other Websites',
              'Your Choices',
              'Accessing and Correcting Your Personal Information',
              'Children',
              'Contact Us',
            ].map((item, idx) => (
              <a href={`#section-${idx}`} key={idx} className={styles.tocItem}>
                {idx + 1}. {item}
              </a>
            ))}
          </div>
        </div>
        <img src={privacyImg} alt="Privacy Policy Illustration" className={styles.image} />
      </section>

      <div className={styles.container}>
        {policyData.map((item, index) => (
          <div id={`section-${index}`} className={styles.card} key={index}>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
